module.exports = __webpack_public_path__ + "static/media/login_user.8e6568a0.jpg";